import { Capacitor } from '@capacitor/core';
import { PushNotifications } from '@capacitor/push-notifications';
import api from './api';

/**
 * Get cached FCM token from localStorage
 */
export const getStoredFcmToken = () => {
    return localStorage.getItem('fcm_token');
};

/**
 * Save FCM token to localStorage
 */
export const setStoredFcmToken = (token) => {
    if (token) {
        localStorage.setItem('fcm_token', token);
    }
};

/**
 * Register user device to SIAKAD backend (POST /api/fcm/token)
 * Can be called right after login or whenever a new FCM token is received.
 * 
 * @param {string|null} customToken - Optional FCM token if already obtained
 * @returns {Promise<boolean>}
 */
export const registerUserDevice = async (customToken = null) => {
    try {
        const authToken = localStorage.getItem('token');
        if (!authToken) {
            console.log('[DeviceService] User is not logged in, skipping device registration.');
            return false;
        }

        let token = customToken || getStoredFcmToken();

        if (Capacitor.isNativePlatform()) {
            // If token is not cached yet, ensure permissions are granted and trigger register()
            if (!token) {
                try {
                    let perm = await PushNotifications.checkPermissions();
                    if (perm.receive !== 'granted') {
                        perm = await PushNotifications.requestPermissions();
                    }
                    if (perm.receive === 'granted') {
                        await PushNotifications.register();
                    }
                } catch (permErr) {
                    console.warn('[DeviceService] Push permissions check/register warning:', permErr);
                }
                token = getStoredFcmToken();
            }
        }

        if (token) {
            console.log('[DeviceService] Registering device token to server...');
            await api.post('/fcm/token', {
                token: token,
                platform: Capacitor.getPlatform(),
            });
            console.log('[DeviceService] User device successfully registered.');
            return true;
        }

        // If native and still no token in localStorage, trigger register() so 'registration' listener handles it
        if (Capacitor.isNativePlatform()) {
            try {
                await PushNotifications.register();
            } catch (regErr) {
                console.warn('[DeviceService] PushNotifications.register error:', regErr);
            }
        }

        return false;
    } catch (err) {
        console.error('[DeviceService] Failed to register user device:', err);
        return false;
    }
};
